export { default as PromotionBanner } from './PromotionBanner';
